import { useContext } from "react";


export const useStatus = (ChronoContext) => {
  const  chronoContext:any = useContext(ChronoContext);
  return chronoContext &&  chronoContext.staticData  ? chronoContext.staticData.status : "";
}